import {AutoProjectStatusTabs} from '../../AutoProjectStatusTabs/Config/AutoProjectStatusTabs.config';


const useAutoStartTrainingModal = ({setValue, startTrainingBtn, setOpen}) => {

    const handleStartTrainingBtn = async () => {
        try {
            await startTrainingBtn();
            setValue(AutoProjectStatusTabs.TrainingStatus);
            setOpen(false);
        } catch (e) {
            console.log(e);
        }

    };

    return {handleStartTrainingBtn};
};

export default useAutoStartTrainingModal;
